import { get, post, patch, del } from './client.js';
const base = (wsId) => `/workspaces/${wsId}/territories`;
export const list         = (wsId)                  => get(base(wsId));
export const create       = (wsId, dto)             => post(base(wsId), dto);
export const update       = (wsId, id, dto)         => patch(`${base(wsId)}/${id}`, dto);
export const remove       = (wsId, id)              => del(`${base(wsId)}/${id}`);
export const assignMember = (wsId, id, userId)      => post(`${base(wsId)}/${id}/members`, { userId });
